/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';
import AppNavTopLevel from '../../../components/appNav/AppNavTopLevel';
import { ProfileThemedSecondaryNav } from '../../../components/SecondaryNav';
import ContentFrame from '../../../applicationFrame/ContentFrame';
import AppNavPhrases from '../../../../phraseKeys/AppNav.phrase';
import { ScrollAwareContext, ScrollAwareItem, ScrollAwareScroller } from '../../../components/ScrollAware';

import ProfileInfo from './components/ProfileInfo';
import ProfileTheme from './components/ProfileTheme';
import ProfilePrivacyContent from './ProfilePrivacy/ProfilePrivacyContent';

import RouteNames from '../../RouteNames';

class Profile extends React.Component {

  UNSAFE_componentWillMount() {
    this.props.getInitialData();
    this.props.loadProfileData(this.props.profileId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.profileId !== this.props.profileId && this.props.profileId) {
      this.props.loadProfileData(this.props.profileId);
    }
  }

  renderTitle(titleValues) {
    return (
      <AppHeaderScrollableText id={titleValues.id} values={titleValues.values} />
    );
  }

  renderSecondaryNav(routeName) {
    const { secondaryNav } = this.props;
    return (<ScrollAwareItem
      isSticky
      hasDropShadow
    >
      <ProfileThemedSecondaryNav
        selectSecondaryNav={this.props.actions.selectSecondaryNav}
        secondaryNav={secondaryNav(this.props.isMainProfile, routeName)}
      />
    </ScrollAwareItem>);
  }

  render() {
    const { secondaryNavLinks } = this.props;
    const titleValues = AppNavPhrases.profile.title(this.props.isMainProfile, this.props.profile.greetingName());

    return (
      <div>
        <ScrollAwareContext>
          <AppNavTopLevel />

          <ContentFrame className="bkgd-color-light-neutral">
            <Switch>
              <Route exact path={RouteNames.profileSettings()}>
                <ScrollAwareScroller>
                  {this.renderTitle(titleValues)}
                  {this.renderSecondaryNav(secondaryNavLinks.settings)}

                  <ProfileTheme goToLanguages={this.props.goToLanguages} />
                </ScrollAwareScroller>
              </Route>
              <Route exact path={RouteNames.profilePrivacy()}>
                <ScrollAwareScroller>
                  {this.renderTitle(titleValues)}
                  {this.renderSecondaryNav(secondaryNavLinks.privacy)}

                  <ProfilePrivacyContent {...this.props} />
                </ScrollAwareScroller>
              </Route>
              <Route path="/">
                <ScrollAwareScroller>
                  {this.renderTitle(titleValues)}
                  {this.renderSecondaryNav(secondaryNavLinks.info)}

                  <ProfileInfo {...this.props} />
                </ScrollAwareScroller>
              </Route>
            </Switch>
          </ContentFrame>

        </ScrollAwareContext>
      </div>
    );
  }
}
Profile.propTypes = {
  content: PropTypes.element,
  profile: PropTypes.object,
  profileId: PropTypes.number,
  isMainProfile: PropTypes.bool,
  isShared: PropTypes.bool,
  getInitialData: PropTypes.func,
  loadProfileData: PropTypes.func,
  goToLanguages: PropTypes.func,
  actions: PropTypes.shape({
    selectSecondaryNav: PropTypes.func,
  }),
  secondaryNavLinks: PropTypes.object,
  secondaryNav: PropTypes.func,
};

export default Profile;
